import { render, staticRenderFns } from "./TicketAction.vue?vue&type=template&id=b84c455a&scoped=true&"
import script from "./TicketAction.vue?vue&type=script&lang=js&"
export * from "./TicketAction.vue?vue&type=script&lang=js&"
import style0 from "./TicketAction.vue?vue&type=style&index=0&id=b84c455a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84c455a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
